<template>
  <button
    v-if="showBackButton"
    ref="focusOnElement"
    class="btn btn-primary btn-back close-thought-button"
    @click="emitCloseThought()"
  >
    {{ domainStore.translate('discuss.general.project.back-to-list-button') }}
  </button>
  <button
    v-if="showBackButton"
    class="btn btn-primary btn-back close-thought-button-mobile mx-1"
    @click="emitCloseThought({ jumpToMap: true })"
  >
    {{ domainStore.translate('discuss.general.project.back-to-list-button') }}
  </button>
  <wdw-dynbox>
    <vue-loading v-if="loading" :loadingMessage="domainStore.translate('thought.general.message.loading')" />
    <Message v-if="thoughtNotFoundError" severity="error" key="not-found">
      {{ domainStore.translate('thought.general.message.not-found', { id: thoughtid }) }}
    </Message>
    <!-- {{thought}} -->
    <!-- <thought-content
            v-if="!loading && thought"
              :thought="thought"
              :topic="topic"
              @editThought="emitEditThought(thoughtid, thought.topic.id)"
            /> -->
    <div v-if="!loading && !thoughtNotFoundError">
      <div class="thought-wrapper" :class="thoughtClass">
        <div class="row">
          <div class="col-md-12">
            <avatar
              :showSocialSharing="canShowSocialSharing"
              :user="thought.owner ? thought.owner : {}"
              :anon="thoughtIsAnonym(thought)"
              :context_obj="thought"
              :enable_edit="canEditThought(thought)"
              :show_status_label="isOwnThought || (user && user.type == 'admin')"
              :topic="topic"
              @edit="emitEditThought(thoughtid, thought.topic.id)"
            />
          </div>
        </div>
        <div class="row widget-content">
          <div :class="displayMap ? 'col-md-8' : 'col-md-12'">
            <thought-content
              :thought="thought"
              :topic="topic"
              @editThought="emitEditThought(thoughtid, thought.topic.id)"
            />
          </div>
          <div v-if="displayMap" :class="displayMap ? 'col-md-4' : ' '">
            <ol-map
              :domainid="domainid"
              :config="mapConfig(project)"
              :height="250"
              :initial_lat="thought.location.lat"
              :initial_lon="thought.location.lon"
              :initial_zoom="15"
              :showMarkerAtInitialPosition="thought.marker_uri"
              :useDeviceLocation="false"
            />
            <p v-if="thought.address" class="address">
              <span class="bold-text">{{ domainStore.translate('discuss.thought.field.address') }}:</span>
              {{ thought.address }}
            </p>
          </div>
        </div>
      </div>
      <thought-support-controls
        v-if="canShowThoughtVoteButton && topic.votetype != 'stars'"
        :topic="topic"
        :thought="thought"
        :signalRefresh="voteRefreshCount"
        @support-requires-comment="onVoteRequiresComment"
        @support-vote-sent="onVoteSuccess"
      />
      <span
        v-if="
          topic !== null &&
          (canCommentOnThoughts(topic) || canCommentAfterLogin(topic)) &&
          thought.can_show_comment_button
        "
        class="create-button"
      >
        <button
          v-if="!isHiddenThought"
          class="btn wdw-thought-btn wdw-thought-comment-button"
          :class="commentBtnClasses"
          :disabled="newComment"
          :title="domainStore.translate('discuss.comment.create.button-title')"
          v-tooltip.bottom="domainStore.translate('discuss.comment.create.button-title')"
          @click="clickNewCommentButton"
        >
          <font-awesome-icon :icon="['far', 'comment']" aria-hidden="true" />
          <span class="visually-hidden">{{ domainStore.translate('discuss.comment.create.button-title') }}</span>
        </button>
        <OverlayPanel
          v-if="!isLoggedIn"
          ref="loginOP"
          :showCloseIcon="true"
          :dismissable="true"
          appendTo="body"
          class="wdw-widgets"
        >
          <p>{{ domainStore.translate('discuss.comment.message.requires-login') }}</p>
          <Login :domainid="domainid" />
        </OverlayPanel>
      </span>
      <span v-if="topic !== null && topic.allow_support" class="create-button">
        <button
          v-if="!isHiddenThought"
          class="btn wdw-thought-btn wdw-thought-comment-button"
          :class="commentBtnClasses"
          :onclick="onSupportClick"
          :title="domainStore.translate('discuss.thought.participate-button-title')"
          v-tooltip.bottom="domainStore.translate('discuss.thought.participate-button-title')"
        >
          <font-awesome-icon :icon="['fas', 'user-plus']" aria-hidden="true" />
          <span class="visually-hidden">{{ domainStore.translate('discuss.thought.participate-button-title') }}</span>
        </button>
      </span>
      <span
        v-if="topic !== null && (canFeedbackOnThoughts(topic) || canFeedbackAfterLogin(topic))"
        class="create-button"
      >
        <button
          v-if="!isHiddenThought"
          class="btn wdw-thought-btn wdw-thought-feedback-button"
          :class="feedbackBtnClasses"
          :disabled="newFeedback"
          v-tooltip.bottom="
            feedbackState.response
              ? domainStore.translate('discuss.feedback.button.edit')
              : domainStore.translate('discuss.feedback.button.create')
          "
          @click="clickFeedbackButton"
        >
          <font-awesome-icon :icon="['fas', 'circle-arrow-right']" aria-hidden="true" />
          <span class="visually-hidden">{{ domainStore.translate('discuss.feedback.title') }}</span>
        </button>
        <OverlayPanel
          v-if="!isLoggedIn"
          ref="loginFeedbackOP"
          :showCloseIcon="true"
          :dismissable="true"
          appendTo="body"
          class="wdw-widgets"
        >
          <p>{{ domainStore.translate('discuss.feedback.message.requires-login') }}</p>
          <Login :domainid="domainid" />
        </OverlayPanel>
      </span>
      <VoteWeight :topic="topic" :thought="thought" />

      <div v-if="topic.votetype == 'stars'">
        <div class="d-flex flex-row flex-wrap">
          <div class="me-3" v-if="canShowThoughtVoteButton">
            <thought-support-controls
              :topic="topic"
              :thought="thought"
              :signalRefresh="voteRefreshCount"
              :fromList="true"
              @support-requires-comment="onVoteRequiresComment"
              @support-vote-sent="onVoteSuccess"
            />
          </div>
          <div v-if="canShowVoteStats && !config.hideVoting">
            <vote-stats :topic="topic" :voteInfo="voteInfo" />
          </div>
        </div>
      </div>

      <div v-if="canShowVoteStats && topic.votetype != 'stars'" class="mt-3 small">
        <vote-stats :topic="topic" :voteInfo="voteInfo" />
      </div>
      <attachments v-if="thought.files.length > 0" :files="thought.files" />
      <admin-link :links="thought.links" />
    </div>
  </wdw-dynbox>
  <template v-if="thoughtLoaded && topic">
    <div ref="feedbackContainer">
      <feedback-response
        v-if="newFeedback"
        :thought="thought"
        :topic="topic"
        @feedback-form-close="onFeedbackFormClosed"
      />
    </div>
    <statements :thoughtid="thoughtid" />
    <feedback-response-stats
      v-if="!isHiddenThought"
      :topic="topic"
      :thought="thought"
      :expanded="expandFeedbackStats"
    />
    <div ref="commentListContainer">
      <comment-list
        :thought="thought"
        :topic="topic"
        :loadAll="true"
        :signalRefresh="refreshCount"
        :showNewComment="newComment"
        :newCommentText="newCommentText"
        :newCommentVote="newCommentVote"
        :onNewCommentFromList="actions.openCommentForm"
        @comment-form-close="onCommentFormClosed"
        @comment-updated="onMyCommentUpdated"
        @comment-vote-sent="onVoteWithCommentSent"
      />
    </div>

    <!-- same back-btn behaviour as the top one-->
    <button v-if="showBackButton" class="btn btn-primary btn-back close-thought-button" @click="emitCloseThought()">
      {{ domainStore.translate('discuss.general.project.back-to-list-button') }}
    </button>
    <button
      v-if="showBackButton"
      class="btn btn-primary btn-back close-thought-button-mobile mx-1"
      @click="emitCloseThought({ jumpToMap: true })"
    >
      {{ domainStore.translate('discuss.general.project.back-to-list-button') }}
    </button>
  </template>
</template>

<script>
import { onBeforeMount, toRefs, ref, watch, computed, toRef, onMounted, onUpdated } from 'vue';

import { userStore } from '@/store/user-store';
import { domainStore } from '@/store/domain-store';
import { projectStore } from '@/store/project-store';
import { thoughtStore } from '@/store/thought-store';
import thoughtRepository from '@/api/thoughtRepository';

import Avatar from '@/components/discuss/general/Avatar.vue';
import WdwDynbox from '@/components/general/WdwDynbox.vue';
import ThoughtContent from '@/components/discuss/thought/Content.vue';
import Attachments from '@/components/general/Attachments.vue';
import ThoughtSupportControls from '@/components/discuss/thought/SupportControls.vue';
import CommentList from '@/components/discuss/comment/CommentList.vue';
import VoteStats from '@/components/discuss/thought/VoteStats.vue';
import VueLoading from '@/components/general/Loading';
import Login from '@/components/user/Login.vue';
import Statements from '@/components/discuss/thought/Statements.vue';
import OlMap from '@/components/general/OlMap.vue';
import AdminLink from '@/components/general/AdminLink.vue';
import WdwSocialSharing from '@/components/general/WdwSocialSharing.vue';
import FeedbackResponse from '@/components/discuss/feedback/FeedbackResponse.vue';
import FeedbackResponseStats from '@/components/discuss/feedback/FeedbackResponseStats.vue';
import OverlayPanel from 'primevue/overlaypanel';
import Message from 'primevue/message';
import VoteWeight from '@/components/discuss/thought/VoteWeight.vue';

import useStringManip from '@/composables/general/useStringManip';
import useThoughtEvents from '@/composables/thought/useThoughtEvents';
import useThoughtConfig from '@/composables/thought/useThoughtConfig';
import useThoughtHelpers from '@/composables/thought/useThoughtHelpers';
import useTopicConfig from '@/composables/topic/useTopicConfig';
import useToggler from '@/composables/general/useToggler';
import useMapProject from '@/composables/map/useMapProject';
import useThoughtFeedbackState from '@/composables/thought/useThoughtFeedbackState';
import { useElementVisibility } from '@vueuse/core';

import ThoughtEventMixins from '@/mixins/ThoughtEventMixins';

// TODO -> fully implement
// [] -> when comment requires login, open login dialog
// [] -> fix checking canComment with correct topic

export default {
  name: 'ThoughtWrapper',
  mixins: [ThoughtEventMixins],
  props: {
    thoughtid: {
      type: Number,
      required: true,
    },
    showBackButton: {
      type: Boolean,
      default: true,
    },
    config: {
      type: Object,
      default: () => ({}),
    },
    actions: {
      type: Object,
      default: () => ({}),
    },
  },

  setup(props, context) {
    const { thoughtid, config, actions } = toRefs(props);
    const { emitCloseThought, emitEditThought, emitSetMapCenter } = useThoughtEvents(context);
    const { canEditThought, canShowSocialShare, thoughtIsAnonym } = useThoughtConfig();
    const { toggleValue: loaderFetchingThought, toggle: toggleLoaderFetchingThought } = useToggler(false);
    const { toggleValue: thoughtNotFoundError, set: setThoughtNotFoundError } = useToggler(false);
    const { canCommentOnThoughts, canCommentAfterLogin, canFeedbackOnThoughts, canFeedbackAfterLogin } =
      useTopicConfig();
    const { feedbackState } = useThoughtFeedbackState(props.thoughtid);
    const { mapConfig } = useMapProject();
    const { getCurrenThoughtUri } = useThoughtHelpers();
    const { truncate } = useStringManip();
    const refreshCount = ref(0);
    const voteRefreshCount = ref(0);
    const newComment = ref(false);
    const newFeedback = ref(false);
    const expandFeedbackStats = ref(true);
    // const topic = ref(null);
    const newCommentText = ref('');
    const newCommentVote = ref(0);
    const voteInfo = ref(null);
    const focusOnElement = ref(null);
    const commentListContainer = ref(HTMLElement | null);
    const feedbackContainer = ref(HTMLElement | null);

    const temporaryThought = ref(null);
    // html element refs
    const loginOP = ref();
    const loginFeedbackOP = ref();

    // computed
    const thought = computed(() => {
      return thoughtStore.getThought(thoughtid.value);
    });

    const topic = computed(() => {
      const data = projectStore.getFetchedTopic(thought.value?.topic.id);
      return data;
    });
    //false = thought is there
    const loading = computed(() => {
      return thought.value === undefined && topic.value === undefined && !thoughtNotFoundError.value ? true : false;
    });
    const thoughtClass = computed(() => {
      return 'thought-' + props.thoughtid;
    });

    //false = thought is there
    const user = computed(() => {
      return userStore.getState().user;
    });
    const isLoggedIn = computed(() => {
      return userStore.isLoggedIn();
    });
    const isOwnThought = computed(() => {
      if (thought.value && thought.value.owner) {
        return user.value && user.value.id == thought.value.owner.id;
      }
      return false;
    });
    const domainid = computed(() => {
      return domainStore.getState().domainid;
    });
    const domain = computed(() => {
      return domainStore.getState().domain;
    });
    const canShowSocialSharing = computed(() => {
      return domain.value ? domain.value.enable_social_sharing : false;
    });
    const isHiddenThought = computed(() => {
      if (thought.value && thought.value.status) {
        return thought.value.status == 'hide';
      }
      return false;
    });
    const canShowThoughtVoteButton = computed(() => {
      if (topic.value) {
        if (topic.value.allow_voting_per_thought == 1) {
          return thought.value.allow_voting == 1 && !isHiddenThought.value;
        }
        return topic.value.new_votes;
      }
      return false;
    });
    const canShowVoteStats = computed(() => {
      return (
        voteInfo.value !== null && // Vote statistic exists
        topic.value != null && // Topic exists
        !isHiddenThought.value && // Thought is visible
        (topic.value.displayvotes === 'always' || // Always display the vote
          (!topic.value.new_votes && topic.value.votetype !== 'none' && topic.value.displayvotes == 'aftervote')) // Can only display after vote is closed
      );
    });
    const thoughtLoaded = computed(() => {
      return !isHiddenThought.value && !loaderFetchingThought.value && !thoughtNotFoundError.value && thought.value;
    });
    const commentBtnClasses = computed(() => {
      return {
        disabled: newComment.value,
      };
    });
    const feedbackBtnClasses = computed(() => {
      return {
        disabled: newFeedback.value,
        feedback_received: feedbackState.response ? true : false,
      };
    });
    const project = computed(() => {
      return projectStore.getState().project;
    });
    const displayMap = computed(() => {
      return project.value && thought.value.location && props.config.showMapPreview;
    });

    // methods
    function checkForLocation(thought) {
      if (thought.location && thought.location.lat && thought.location.lon) {
        const mapsettings = project.value.map_settings;
        const params = {
          lat: thought.location.lat,
          lon: thought.location.lon,
          zoom: mapsettings.zoom.max, // Per T17159, focusing on a thought will zoom the map in to the max value
        };
        if (isHiddenThought.value && thought.marker_uri) {
          params.marker_uri = thought.marker_uri;
        }
        emitSetMapCenter(params);
      }
    }
    function fetchThoughtVoteInfo() {
      thoughtRepository
        .getVoteInfo(thoughtid.value)
        .then(t => {
          voteInfo.value = t;
        })
        .catch(e => {
          voteInfo.value = null;
        });
    }

    function fetchThought() {
      toggleLoaderFetchingThought();
      thoughtStore
        .fetchThought(thoughtid.value)
        .then(t => {
          // topic.value = projectStore.getFetchedTopic(t.topic.id);
          setThoughtNotFoundError(false);
          checkForLocation(t);
          //TODO: DELETE TOGGLER
          toggleLoaderFetchingThought();
          fetchThoughtVoteInfo();
        })
        .catch(e => {
          // Thought not found
          setThoughtNotFoundError(true);
          toggleLoaderFetchingThought();
        });
    }

    function showNewComment(val = true) {
      newComment.value = val;
    }
    function clickNewCommentButton(event) {
      // to prevent error in customer-systems T14938
      event.stopPropagation();
      event.preventDefault();

      //Check if user is logged in
      if (canCommentOnThoughts(topic.value)) {
        //Show create form when user is logged in
        showNewComment(true);
      } else if (canCommentAfterLogin(topic.value)) {
        loginOP.value.show(event);
      } else {
        console.error('error: cannot create comment, but button visible/clicked');
      }
    }
    function onVoteRequiresComment(param) {
      // When voting requires comment to be sent
      showNewComment(true);
      if (param.commented_voting == 'optional') {
        newCommentText.value = domainStore.translate('discuss.thought.message.vote-optional-comment');
      } else if (param.commented_voting == 'force') {
        newCommentText.value = domainStore.translate('discuss.thought.message.vote-requires-comment');
      } else {
        newCommentText.value = '';
      }
      newCommentVote.value = param.voteValue;
    }
    function resetCommentForm() {
      showNewComment(false);
      newCommentText.value = '';
      newCommentVote.value = 0;
    }
    function onCommentFormClosed() {
      // comment form closed
      resetCommentForm();
    }
    function onMyCommentUpdated() {
      // added new comment or existing comment is updated
      resetCommentForm();
    }
    function onVoteSuccess(vote) {
      // Successful vote. This does not include comment
      fetchThoughtVoteInfo();
    }
    function onVoteWithCommentSent(vote) {
      // Successful vote with comment
      // The vote object has the latest vote. We need to expose it to our SupportControls
      // Tell supportControls to refresh
      voteRefreshCount.value += 1;
      fetchThoughtVoteInfo();
    }
    function onSupportClick(e) {
      if (topic.value && topic.value.allow_support) {
        thoughtRepository.getSupportEmailContet(thought.value.id).then(data => {
          const supportEmailContent = data.support_email_content;
          window.location.href = `mailto:${topic.value.support_email}?subject=${encodeURIComponent(
            supportEmailContent.subject
          )}&body=${encodeURIComponent(supportEmailContent.body)}`;
        });
      }
    }

    function showNewFeedback(val = true) {
      newFeedback.value = val;
    }
    function onFeedbackFormClosed(data) {
      if (data) {
        feedbackState.response = data.response;
        // force refetch thought, to get updated feedback statistics
        thoughtStore.updateFeedbackStatisticForThought(thoughtid.value);
      }
      // feedback form closed
      showNewFeedback(false);
    }
    function clickFeedbackButton(event) {
      // to prevent error in customer-systems T14938
      event.stopPropagation();
      event.preventDefault();

      //Check if user is logged in
      if (canFeedbackOnThoughts(topic.value)) {
        //Show create form when user is logged in
        showNewFeedback(true);
      } else if (canFeedbackAfterLogin(topic.value)) {
        loginFeedbackOP.value.show(event);
      } else {
        console.error('error: cannot create feedback_response, but button visible/clicked');
      }
    }
    function updateCommentFormFromActionChange() {
      if (actions.value.openCommentForm) {
        newComment.value = true;
        if (actions.value.commentHint) {
          newCommentText.value = actions.value.commentHint;
          newCommentVote.value = actions.value.voteValue;
        }
      } else {
        resetCommentForm();
      }
      if (actions.value.openFeedbackForm) {
        showNewFeedback(true);
      } else {
        showNewFeedback(false);
      }
      if (actions.value.openFeedbackStats) {
        expandFeedbackStats.value = true;
      } else {
        expandFeedbackStats.value = false;
      }
    }

    // init by fetching thought
    onBeforeMount(() => {
      fetchThought();
    });
    onMounted(() => {
      updateCommentFormFromActionChange();
    });
    // WATCHERS
    watch(thoughtid, (thoughtid, oldThoughtid) => {
      if (thoughtid !== oldThoughtid) {
        fetchThought();
        // update focus if opened thought changes
        if (focusOnElement.value) {
          focusOnElement.value.focus();
        }
      }
    });
    // WATCHERS
    watch(actions, () => {
      updateCommentFormFromActionChange();
    });
    watch(useElementVisibility(focusOnElement), (newVisible, oldVisible) => {
      if (newVisible && !oldVisible && focusOnElement.value) {
        focusOnElement.value.focus();
      }
    });
    return {
      // VARS
      thoughtNotFoundError,
      thought,
      isLoggedIn,
      user,
      loaderFetchingThought,
      refreshCount,
      voteRefreshCount,
      newComment,
      newFeedback,
      loginOP,
      loginFeedbackOP,
      topic,
      newCommentText,
      newCommentVote,
      voteInfo,
      commentListContainer,
      feedbackContainer,
      temporaryThought,
      mapConfig,
      truncate,
      feedbackState,
      expandFeedbackStats,
      focusOnElement,
      // Computed
      domain,
      canShowSocialSharing,
      thoughtClass,
      isOwnThought,
      isHiddenThought,
      thoughtLoaded,
      domainid,
      commentBtnClasses,
      feedbackBtnClasses,
      canShowVoteStats,
      canShowThoughtVoteButton,
      project,
      displayMap,
      loading,
      // Methods
      canEditThought,
      canShowSocialShare,
      thoughtIsAnonym,
      canCommentOnThoughts,
      canCommentAfterLogin,
      canFeedbackOnThoughts,
      canFeedbackAfterLogin,
      showNewComment,
      clickNewCommentButton,
      clickFeedbackButton,
      onFeedbackFormClosed,
      onVoteRequiresComment,
      onCommentFormClosed,
      onMyCommentUpdated,
      onVoteWithCommentSent,
      onVoteSuccess,
      getCurrenThoughtUri,
      onSupportClick,
      domainStore,
      // EMITS
      emitCloseThought,
      emitEditThought,
    };
  },

  components: {
    OverlayPanel,
    Login,
    Avatar,
    VueLoading,
    ThoughtContent,
    WdwDynbox,
    CommentList,
    ThoughtSupportControls,
    VoteStats,
    VoteWeight,
    Attachments,
    Statements,
    OlMap,
    FeedbackResponse,
    FeedbackResponseStats,
    AdminLink,
    Message,
  },
};
</script>

<style scoped lang="scss">
a {
  cursor: pointer;
}
.ml {
  margin-left: 5px;
}
.address {
  margin-top: 15px;
  padding-left: 5px;
}
.bold-text {
  font-weight: 800;
}

.btn-back.close-thought-button-mobile {
  display: none;
}
@media (max-width: 575px) {
  .btn-back.close-thought-button-mobile {
    display: inline-block;
  }
  .btn-back.close-thought-button {
    display: none;
  }
}
</style>
